import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: "600",
  color: COLORS.black,
};

export const H6 = ({ children, fontWeight, color, dangerouslySetInnerHTML, marginTop, fontFamily}) => {
  return (
    <Typography variant="h6" dangerouslySetInnerHTML={dangerouslySetInnerHTML} sx={{ fontWeight, color, marginTop, fontFamily}}>
      {children}
    </Typography>
  );
};

H6.propTypes = {
  fontWeight: PropTypes.string,
  color: PropTypes.string,
};

H6.defaultProps = defaultProps;

export default H6;
